import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxesStacked } from '@fortawesome/free-solid-svg-icons';

export default function InventaireRenderer({ notification }) {
    const { data } = notification;
    return (
        <NavLink
            to={`/inventaire/${data?.inventaireId}`}
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
        >
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                <span style={{
                    background: '#ede9fe', borderRadius: 8, padding: '6px 8px',
                    flexShrink: 0,
                }}>
                    <FontAwesomeIcon icon={faBoxesStacked} style={{ color: '#7c3aed' }} />
                </span>
                <div>
                    <div style={{ fontWeight: 600, fontSize: 13, color: '#111827' }}>
                        Inventaire tournant généré
                    </div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                        {data?.totalProduits} produits à vérifier cette semaine
                    </div>
                </div>
            </div>
        </NavLink>
    );
}
